import { render, staticRenderFns } from "./HttpRequestSampleTokens.vue?vue&type=template&id=4973ed46"
import script from "./HttpRequestSampleTokens.vue?vue&type=script&lang=js"
export * from "./HttpRequestSampleTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports